var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-center-wrap',[_c('div',{staticClass:"history"},[_c('div',{staticClass:"header"},[_vm._v("竞猜历史")]),_c('BetHistory')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }